import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/pages/index.vue'
import aboutUs from '@/pages/aboutUs.vue'
import contactUs from '@/pages/contactUs.vue'
import quotation from '@/pages/quotation.vue'
import article from '@/pages/article.vue'
import articleInfo from '@/pages/articleInfo.vue'
import video from '@/pages/video.vue'
import videoInfo from '@/pages/videoInfo.vue'

Vue.use(Router)
const routes = [
    {
      path: '/',
      name: 'index',
      component: Index
    },

    {
 	   path: '/aboutUs',
 	   name: 'aboutUs',
 	   component: aboutUs
 	},

    {
 	   path: '/contactUs',
 	   name: 'contactUs',
 	   component: contactUs
 	},

    {
 	   path: '/quotation',
 	   name: 'quotation',
 	   component: quotation
 	},

	{
 	   path: '/article',
 	   name: 'article',
 	   component: article
 	},

	{
 	   path: '/articleInfo',
 	   name: 'articleInfo',
 	   component: articleInfo
 	},

	{
 	   path: '/video',
 	   name: 'video',
 	   component: video
 	},

	{
 	   path: '/videoInfo',
 	   name: 'videoInfo',
 	   component: videoInfo
 	},
  ]
const router = new Router({
  mode: 'history',
  routes: routes
})
router.beforeEach((to, from, next) => {
  if(to && to.path && routes.filter( p => p.path === to.path ).length > 0){
    next();
  }else{
    location.href="http://www.huifeng1997.com/errorPage/index.html";
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js